import React, { useContext , useEffect, useState} from 'react';
import EirReviewOrderHeader from './EirReviewOrderHeader';
import EirPorting from '../eir-porting/EirPorting';
import OrderDetails from '../eir-review-order/OrderDetails';
import TopUp from '../eir-review-order/TopUp';
import { EirOrderSummary } from '../eir-checkout/EirOrderSummary';
import { Grid, Container } from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { CheckoutContext } from '../eir-checkout/EirCheckoutContainer';
import { CONTRACT_SUMMARY_LINK } from '../eir-prepay-constants/ApplicationConstants';

export default function EirReviewOrderContainer(props) {
    const { handleSubmit } = useForm();
    const [continueDisabled, setcontinueDisabled] = useState(false);
    const { setCurrentUrl, nextStepUrl } = props;
    const history = useHistory();
    const location = useLocation();
    const currentUrl = location.pathname;
    const {cartDetails,totalPrice} = useContext(CheckoutContext);
    
    const setconfirmBtnStatus = response => {
        setcontinueDisabled(response);
    };

    useEffect(() => {
        setCurrentUrl(currentUrl);
        if(!cartDetails.plan){
            console.log('details>>>',cartDetails)
            setcontinueDisabled(false);
        }
	}, []);
   
    const onSubmit = data => {
        history.push(nextStepUrl);
    };
    return (
        <form>
                <Grid className='content-holder'>
                    <EirReviewOrderHeader details={cartDetails}></EirReviewOrderHeader>
                    <div className='mobileViewPadding'>
                        {' '}
                        <EirPorting details={cartDetails} setconfirmBtnStatus={setconfirmBtnStatus} />                        
                    </div>     
                    <OrderDetails details={cartDetails}></OrderDetails>
                    {cartDetails.availableTopUp?<TopUp details={cartDetails}></TopUp>:''}
                    <p className='contract-summary mobileViewPadding'>To see key conditions of your prepay service (your Contract Summary as required under EU regulations) please <a href={CONTRACT_SUMMARY_LINK} rel="noopener noreferrer" target="_blank"> click here.</a></p>

                </Grid>
            {cartDetails ? (
                <EirOrderSummary
                    buttonLabel='Continue'
                    price={totalPrice}
                    continueDisabled={!continueDisabled}
                    handleNext={handleSubmit(onSubmit)}
                />
            ) : (
                ''
            )}
        </form>
    );
}



